<template>
    <div class="row">
        <div class="col-12 col-md-8">
            <emblem>{{ data.name }}</emblem>
            <div class="legislation-info card h-auto card-filled">
                <div class="card__text h-100 justify-content-center px-2 py-2">
                    <ul class="list-unstyled">
                        <li v-if="data.name" class="mb-2">
                            <span class="mr-3 font-weight-bold">Name:</span>
                            {{ data.name }}
                        </li>
                        <li v-if="data.info" class="mb-2">
                            <span class="mr-3 font-weight-bold">Code:</span>
                            {{ data.info }}
                        </li>
                        <li v-if="data.status" class="mb-2">
                            <span class="mr-3 font-weight-bold">Status:</span>
                            {{ data.status }}
                        </li>
                        <li v-if="data.subjects" class="mb-2">
                            <span class="mr-3 font-weight-bold">Thema(s):</span>
                            {{ data.subjects }}
                        </li>
                    </ul>
                    <label class="toggle-switch">
                        <span class="mr-2 font-weight-bold">{{
                            translations.subscribe
                        }}</span>
                        <input
                            v-model="isSubscribed"
                            class="toggle-switch__input"
                            type="checkbox"
                            :disabled="loading"
                            @change="changeSubscription"
                        />
                        <span class="toggle-switch__slider"></span>
                    </label>
                </div>
            </div>
            <emblem v-if="data.process.heading">{{
                data.process.heading
            }}</emblem>
            <detail-process
                v-if="data.process"
                :process="data.process"
            ></detail-process>
            <emblem v-if="data.generalDescription">General remarks</emblem>
            <div
                v-if="data.generalDescription"
                class="general-remarks card h-auto card-filled"
            >
                <div
                    class="card__text h-100 justify-content-center px-2 py-2"
                    v-html="data.generalDescription"
                ></div>
            </div>
            <div v-if="data.furtherDetailItems.length">
                <emblem>Further details</emblem>
                <further-details
                    :details="data.furtherDetailItems"
                ></further-details>
            </div>
            <other-levels
                v-if="data.otherLevels.length"
                :levels="data.otherLevels"
            ></other-levels>
        </div>
        <div class="col-12 col-md-4">
            <emblem v-if="data.relatedNews.items.length">Related news</emblem>
            <related-news
                v-if="data.relatedNews.items.length"
                :news="data.relatedNews"
            ></related-news>
            <emblem v-if="data.relatedEmployee.name">NVB contact</emblem>
            <related-employee
                v-if="data.relatedEmployee.name"
                :member="data.relatedEmployee"
            ></related-employee>
            <emblem v-if="data.positionPapers.length">Position papers</emblem>
            <position-papers
                v-if="data.positionPapers.length"
                :papers="data.positionPapers"
            ></position-papers>
            <emblem
                v-if="
                    data.deadlinesAndConsultations &&
                        data.deadlinesAndConsultations.length
                "
                >Consultations &amp; Deadlines</emblem
            >
            <agenda
                v-if="
                    data.deadlinesAndConsultations &&
                        data.deadlinesAndConsultations.length
                "
                class="h-auto"
                :items="data.deadlinesAndConsultations"
                :translations="translations"
            ></agenda>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import emblem from '@/components/emblem';
import detailProcess from '@/components/legislationMonitor/legislation-detail/detail-process';
import furtherDetails from '@/components/legislationMonitor/legislation-detail/further-details';
import otherLevels from '@/components/legislationMonitor/legislation-detail/other-levels';
import relatedNews from '@/components/legislationMonitor/legislation-detail/related-news';
import relatedEmployee from '@/components/legislationMonitor/legislation-detail/related-employee';
import positionPapers from '@/components/legislationMonitor/legislation-detail/position-papers';
import agenda from '@/components/agenda/agenda';
import translationMixin from '@/mixins/translations';

export default {
    components: {
        emblem,
        detailProcess,
        furtherDetails,
        otherLevels,
        relatedNews,
        relatedEmployee,
        positionPapers,
        agenda
    },
    mixins: [translationMixin],

    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            isSubscribed: false,
            isSubscribedToSubject: false,
            loading: false
        };
    },
    watch: {
        isPublished(val) {
            this.$emit('input', val);
        }
    },
    created() {
        this.isSubscribed = this.data.subscription.legislation;
        this.isSubscribedToSubject = this.data.subscription.legislationSubject;
    },
    methods: {
        changeSubscription() {
            if (this.isSubscribed) {
                this.subscribe();
            } else {
                this.unsubscribe();
            }
        },
        changeSubjectSubscription() {
            if (this.isSubscribedToSubject) {
                this.subscribeToSubject();
            } else {
                this.unsubscribeFromSubject();
            }
        },
        subscribe() {
            this.loading = true;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            axios
                .post(
                    '/umbraco/api/legislation/subscribeToLegislation',
                    this.data.legislationId,
                    config
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        unsubscribe() {
            this.loading = true;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            axios
                .post(
                    '/umbraco/api/legislation/unsubscribeFromLegislation',
                    this.data.legislationId,
                    config
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        subscribeToSubject() {
            this.loading = true;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            axios
                .post(
                    '/umbraco/api/legislation/subscribeToLegislationSubject',
                    this.data.subjectId,
                    config
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        unsubscribeFromSubject() {
            this.loading = true;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            axios
                .post(
                    '/umbraco/api/legislation/unsubscribeFromLegislationSubject',
                    this.data.subjectId,
                    config
                )
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style lang="scss">
.legislation-info ul li {
    display: flex;
}

.legislation-info ul li span {
    flex: 0 1 100px;
}

.general-remarks {
    border-bottom: 5px solid $brand-blue;
}
</style>

<style lang="scss" scoped>
@import '@/scss/helpers/_extensions.scss';
.card {
    margin-bottom: 40px;
    border-bottom: 5px solid $brand-blue;

    @include media-breakpoint-up(lg) {
        margin-bottom: 80px;
    }

    &:hover {
        transform: none;
        @extend %box-shadow;
    }
}

.general-remarks {
    ::v-deep a {
        color: $green;
        text-decoration: none;
    }
}
</style>
